export const getPwaUrlForOnboarding = (): string => {
  const { origin, pathname } = window.location;

  // STAGE
  if (
    origin === 'https://stage.hairio.app'
  ) {
    return 'https://stage-app.hairio.app';
  }

  // PROD
  if (
    origin === 'https://quiz.hairio.app'
  ) {
    return 'https://app.hairio.app';
  }

  return 'https://stage-app.hairio.app';
};
